Solver.cart.age_confirm = async function (event) {
	if (!event || (event && !event.currentTarget)) return;

	const checked = event.currentTarget.checked;
	const btn = document.querySelector('.cart-btn');

	if (!btn) return;

	let req = null;

	if (checked) {
		req = await Solver.api.cart.notes('Customer Confirms Age 21 or Older');
		btn.classList.remove('uk-button-disabled');

		req = await Solver.api.cart.get();

		Solver.cart.data = req.data;
		return;
	}

	req = await Solver.api.cart.notes('');
	btn.classList.add('uk-button-disabled');

	req = await Solver.api.cart.get();
	Solver.cart.data = req.data;
};

/**
 * Updates the cart UI
 * @param { object } cart - http response of cart object
 * @return { object } cart object
 */
Solver.cart.ui = async function (cart) {
	if (!cart) return;

	const cartHTML = document.querySelector('[data-cart]');

	if (cartHTML) {
		const section = cartHTML.getAttribute('data-cart');

		const req = await fetch('/?sections=' + section);

		if (req.error) {
			const message = req.error.message ? req.error.message : req.error;
			console.error(message);
			UIkit.notification(message, { status: 'danger' });
			return { error: message };
		}

		let markup = await req.json();
		markup = markup[section];
		markup = new DOMParser().parseFromString(markup, 'text/html');
		markup = markup.querySelector(`[data-cart="${section}"]`);
		const cartItems = markup.querySelector(`[data-cart="${section}"] [data-cart-items]`);
		const cartSummary = markup.querySelector(`[data-cart="${section}"] [data-cart-summary]`);
		const cartDiscounts = markup.querySelector(`[data-cart="${section}"] [data-cart-discounts]`);
		const cartEmpty = markup.querySelector(`[data-cart="${section}"] [data-cart-empty]`);

		if (cartHTML.querySelector('[data-cart-items]') && cartItems) {
			cartHTML.querySelector('[data-cart-items]').innerHTML = cartItems.innerHTML;
			const liveDiscounts = cartHTML.querySelector('[data-cart-discounts]');
			if (liveDiscounts && cartDiscounts) liveDiscounts.innerHTML = cartDiscounts.innerHTML;
			if (!liveDiscounts && cartDiscounts) cartHTML.querySelector('[data-cart-items]').after(cartDiscounts);
			cartHTML.querySelector('[data-cart-summary]').innerHTML = cartSummary.innerHTML;
		}

		if (!cartHTML.querySelector('[data-cart-items]') && cartItems) {
			cartHTML.querySelector('[data-cart-empty]').remove();
			cartHTML.appendChild(cartItems);
			if (cartDiscounts) cartHTML.appendChild(cartDiscounts);
			cartHTML.appendChild(cartSummary);
		}

		if (cartEmpty) {
			if (cartHTML.querySelector('[data-cart-items]')) {
				cartHTML.querySelector('[data-cart-items]').remove();
			}

			if (cartHTML.querySelector('[data-cart-discounts]')) {
				cartHTML.querySelector('[data-cart-discounts]').remove();
			}

			if (cartHTML.querySelector('[data-cart-summary]')) {
				cartHTML.querySelector('[data-cart-summary]').remove();
			}

			cartHTML.appendChild(cartEmpty);
		}
	}

	const cartQuantity = document.querySelector('[data-cart-count]');
	if (cartQuantity && Solver && Solver.cart && Solver.cart.data.item_count) {
		cartQuantity.innerText = Solver.cart.data.item_count;
	} else {
		cartQuantity.innerText = 0;
	}
	return cart;
};

/**
 * Gets http cart object from http request
 * @param { object } event|optional - user generated DOM event
 * @return { object } cart object
 */
Solver.cart.get = async function (event) {
	if (event && event.preventDefault) event.preventDefault();

	const req = await Solver.api.cart.get();

	if (!req || (req && req.error)) {
		const message = req.error.message ? req.error.message : req.error;
		console.error(message);
		UIkit.notification(message, { status: 'danger' });
		return { error: message };
	}

	Solver.cart.ui(req.data);
	window.Solver.cart.data = req.data;

	return { data: req.data };
};

/**
 * Adds quanity by to cart by variant ID
 * @param { string } variantID - product variant id
 * @param { number } quantity - amount to increment
 * @param { string } sellingPlan|optional - selling plan id for subscription purchases
 * @return { object } cart object
 */
Solver.cart.add = async function (event, variantID, quantity, display = null, sellingPlan = null) {
	if (event && event.preventDefault) event.preventDefault();

	let req = await Solver.api.cart.add(variantID, quantity, sellingPlan);

	if (!req) {
		const message = 'Request could not be completed';
		console.error(message);
		UIkit.notification(message, { status: 'danger' });

		return { error: message };
	}

	if (req && req.error) {
		const message = req.error.message || req.error || 'Could not add to cart';
		console.error('Cart add error:', message);
		UIkit.notification(message, { status: 'danger' });

		return { error: message };
	}

	if (display) {
		UIkit.modal(`#cart-${display}`).show();
		await Solver.asyncTimeout(3000);
		UIkit.modal(`#cart-${display}`).hide();
	}

	req = await Solver.cart.get();

	Solver.cart.ui(req.data);

	return { data: req.data };
};

/**
 * Adds quanity by to cart by variant ID
 * @param { string } id - key(id) of of line item to increment or decrement quantity on
 * @param { number } quantity - amount to increment or decrement per variant id
 * @return { object } cart object
 */
Solver.cart.change = async function (event, id, quantity = 0) {
	if (event && event.preventDefault) event.preventDefault();

	if (!id) return;

	let req = await Solver.api.cart.change({
		id: id.toString(),
		quantity: parseInt(quantity)
	});

	if (!req) {
		const message = 'Request could not be completed';
		console.error(message);
		UIkit.notification(message, { status: 'danger' });

		return { error: message };
	}

	if (req.error) {
		const message = req.error.message ? req.error.message : req.error;
		console.error(message);
		UIkit.notification(message, { status: 'danger' });

		return { error: message };
	}

	req = await Solver.cart.get();

	return { data: req.data };
};
